module.exports = __webpack_public_path__ + "static/media/Regresar.adf40d6d.png";